
import { take } from 'rxjs/operators';
import { Component, OnInit, AfterViewInit, Input, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModalRef, NgbActiveModal } from '@otas/modal/modal-ref';
import { NgbModal } from '@otas/modal/modal';
import { MemberRequest } from '@otas/stoda/model/member/member';
import { AddMemberModalService } from '@otas/membership/add-member-modal/add-member-modal.service';
import { AppConstants } from '../../app.constants';
import { ToasterService } from '../../services/toaster.service';
import * as _ from 'underscore';
import moment from 'moment';
import { IAutoCompleteSettings } from '@otas/utils/custom-components/auto-complete/auto-complete.module';
import { AutoSuggestOption } from '@otas/utils/custom-components/auto-suggest/auto-suggest.component';
@Component({
  selector: 'app-add-member-modal',
  templateUrl: './add-member-modal.component.html',
  styleUrls: ['./add-member-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false
})
export class AddMemberModalComponent implements OnInit, AfterViewInit {
  modalRef: NgbModalRef;
  vazhipadOptions: AutoSuggestOption[] = [];
  nakshatraOptions: AutoSuggestOption[] = [];
  memberForm: UntypedFormGroup = inject(UntypedFormBuilder).group(new MemberRequest());
  selectedFiles: FileList;
  url = signal<any>(null);
  data;
  flag;
  status = 'ACTIVE';
  currentFileUpload: File;
  submitted = false;
  submitting = false;
  memberType;
  prefix;
  typeWiseMemberId;
  @Input() allMemberType: any = [];
  datepickerOpts: any = AppConstants.datePickerOptions;
  vazipadNameSettings: IAutoCompleteSettings = {
    isFocusFirstElement: true, needSelection: true, selectionOnclick: true,
    placeholder: 'Press <space> to see Members',
    isClearAll: true,
  };
  private modalService = inject(NgbModal);
  public toastr = inject(ToasterService);
  private addMemberModalService = inject(AddMemberModalService);
  activeModal = inject(NgbActiveModal);


  ngOnInit() {
    this.getVazipadList();

    this.memberForm.get('isActive').setValue(true);
    this.memberForm.get('status').setValue('ACTIVE');
    const lang = sessionStorage.getItem('language') === 'malayalam';
    if (lang) {
      AppConstants.NAKSHATRAS_MALAYALAM.forEach(element => {
        this.nakshatraOptions.push({ id: element.name, prefix: element.id + '. ', name: element.name });
      });
    } else {
      AppConstants.NAKSHATRAS_.forEach(element => {
        this.nakshatraOptions.push({ id: element.name, prefix: element.id + '. ', name: element.name });
      });
    }


  }
  statusChange(e) {

    if (this.status == 'ACTIVE') {
      this.memberForm.get('isActive').setValue(true);
      this.memberForm.get('isExpired').setValue(false);
    }
    if (this.status == 'INACTIVE') {
      this.memberForm.get('isActive').setValue(false);
      this.memberForm.get('isExpired').setValue(false);
    }
    if (this.status == 'EXPIRED') {
      this.memberForm.get('isActive').setValue(false);
      this.memberForm.get('isExpired').setValue(true);
    }
  }
  getVazipadList() {
    this.addMemberModalService.getMembers().subscribe((res) => {
      _.map(_.sortBy(res.result, 'id'), (member) => {
        this.vazhipadOptions.push({
          id: +member.id,
          prefix: member.id + '.',
          name: member.name,
          object: member
        });
        return member;
      })
    })
    if (!!this.data) {

      this.edit();
    }
  }
  ngAfterViewInit() {
    this.getAllMemberType();
    this.memberForm.controls.status.valueChanges.subscribe((data) => {
      console.log(data)
      if (data == 'ACTIVE') {
        this.memberForm.get('isActive').setValue(true);
        this.memberForm.get('isExpired').setValue(false);
      }
      if (data == 'INACTIVE') {
        this.memberForm.get('isActive').setValue(false);
        this.memberForm.get('isExpired').setValue(false);
      }
      if (data == 'EXPIRED') {
        this.memberForm.get('isActive').setValue(false);
        this.memberForm.get('isExpired').setValue(true);
      }
    });
  }
  setMemberNoUsingType(e) {
    if (this.typeWiseMemberId != null) {
      const string = _.pairs(this.typeWiseMemberId);
      string.forEach(element => {
        if (+element[0] === e.id) {
          this.memberForm.get('memberId').setValue(+element[1] + 1);
        }
      });
    }
  }
  undo(data) {
    data.selected = true;
  }
  save(data) {

  }
  editMemberType(data) {
    const index = this.allMemberType.indexOf(data);
    this.allMemberType.forEach(element => {
      element.selected = true;
    });
    this.allMemberType[index].selected = false;
  }
  edit() {
    if (!!this.data.file) {
      this.url.set('data:image/jpeg;base64,' + this.data.file);
    } else {
      this.url = null;
    }
    const mem = this.data;
    mem.dob = moment(mem.dob).toDate();
    this.memberForm.get('nomineeId').setValue(mem.nomineeId);
    this.memberForm.get('memberId').setValue(mem.memberId);
    this.memberForm.get('isExpired').setValue(mem.expired);
    this.memberForm.get('isActive').setValue(mem.isActive);
    this.memberForm.get('relation').setValue(mem.nomineeRelation);
    this.memberForm.get('dob').setValue(mem.dob);
    this.memberForm.get('type').setValue(mem.typeId);
    this.memberForm.get('phone').setValue(mem.phone);
    this.memberForm.get('email').setValue(mem.email);
    this.memberForm.get('address').setValue(mem.address);
    this.memberForm.get('name').setValue(mem.name);
    this.memberForm.get('star').setValue(mem.star);
    this.memberForm.get('id').setValue(mem.id);
    window.scroll(0, 0);
  }
  selectFile(event) {
    const file = event.target.files.item(0);
    if (file.type.match('image.*')) {
      this.selectedFiles = event.target.files;
      if (event.target.files && event.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (ev: ProgressEvent) => { // called once readAsDataURL is completed
          this.url.set((<FileReader>ev.target).result);
        };
        reader.readAsDataURL(event.target.files[0]);
      }
    } else {
      this.toastr.warning('Invalid File Format!!!!!!!!!!!!!');
    }
  }
  newMemberType(content) {
    this.submitting = false; this.memberType = null; this.prefix = null;
    this.modalRef = this.modalService.open(content, AppConstants.mediumModalOptions);
  }
  submit() {


    if (this.memberForm.invalid) {
      this.submitted = true;
      return;
    }
    if (!!this.memberForm.get('isExpired').value) {
      this.memberForm.get('isActive').setValue(false);
    }
    if (!!this.memberForm.get('isActive').value) {
      this.memberForm.get('isExpired').setValue(false);
    }
    // if(this.flag=='savemember'){
    this.memberForm.removeControl('status');
    // }
    const request = this.memberForm.value;

    if (!!request.dob) {
      request.dob = request.dob * 1;
    }

    // console.log(request);
    if (!!this.selectedFiles) {
      this.currentFileUpload = this.selectedFiles.item(0);
    }
    console.log(request, "add member")

    this.addMemberModalService[!!this.flag ? 'updateMember' : 'saveMember'](request, this.currentFileUpload).pipe(take(1)).subscribe((res) => {
      this.reset();
      // this.getAllMembers();
      this.activeModal.close(true);
    });
  }

  reset() {
    this.memberForm.reset();
    this.url = null;
    // this.isEdit = !!this.isEdit ? true : false;
    this.submitted = false;
    this.selectedFiles = null;
  }

  allMemberTypeModal(content) {
    this.modalRef = this.modalService.open(content);
  }
  getAllMemberType() {
    this.addMemberModalService.getAllMemberType().subscribe(response => {
      this.allMemberType = response.result;
      this.allMemberType.forEach(element => {
        element.selected = true;
      });

    });
  }

  submitMemberType() {
    if (!this.memberType) {
      this.submitting = true;
      return;
    }
    this.addMemberModalService.submitMemberType(this.memberType, this.prefix).pipe(take(1)).subscribe((resp) => {
      if (resp.status === 'SUCCESS') {
        this.modalRef.close();
        this.getAllMemberType();
      }
    });
  }
  close(modalRef) {
    modalRef.close();
  }
}
